import { IconButton } from '@mui/material';

import { useDialog } from '@app/hooks';
import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from '@app/components';
import { Strings } from '@app/constants';
import { IReview } from '../types';
import { AddReview } from './add-review';

interface Props {
  row: IReview;
  isTLSelected?: boolean;
}

const RowActions = ({ row, isTLSelected }: Props) => {
  const menuPopover = useMenuPopover();
  const editDialog = useDialog();

  const actions = [{ label: Strings.rowActions.edit, callback: editDialog.show }];

  return (
    <>
      <IconButton onClick={menuPopover.show}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>
      {editDialog.visible && (
        <AddReview open onClose={editDialog.hide} row={row} isTLSelected={isTLSelected} />
      )}
    </>
  );
};

export { RowActions };
